<template>
  <div class="global-trends-compare">
    <ai-breadcrumb />
    <div class="new-button">
      <guide class="guide-button" :disabled="true" />
    </div>
    <div class="search-content">
      <el-form :inline="true" size="small" class="search-form">
        <el-form-item class="search-form-gutter" :label="$t('globalTrend.year')">
          <el-select style="width: 88px" v-model="currentYear" @change="changeYear" filterable>
            <el-option v-for="item in yearList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search-form-gutter" :label="$t('globalTrend.season')">
          <el-select style="width: 88px" v-model="currentSeason" @change="changeSeason">
            <el-option v-for="item in seasonList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search-form-gutter" :label="'VS ' + $t('globalTrend.year')">
          <el-select style="width: 88px" v-model="currentCompareYear" @change="changeCompareYear" filterable>
            <el-option v-for="item in yearList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search-form-gutter" :label="$t('globalTrend.season')">
          <el-select style="width: 88px" v-model="currentCompareSeason" @change="changeSeason">
            <el-option v-for="item in compareSeasonList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search-form-gutter" :label="$t('globalTrend.sex')">
          <el-select style="width: 88px" v-model="currentSex" clearable>
            <el-option v-for="item in sexList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search-form-gutter" :label="$t('globalTrend.category')">
          <el-select style="width: 112px" v-model="currentCategory" clearable @change="changeCategory">
            <el-option v-for="item in categoryList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search-form-gutter" :label="$t('globalTrend.item')">
          <el-select style="width: 168px" v-model="currentItem" clearable>
            <el-option v-for="item in itemList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" circle @click="fetchData"></el-button>
        </el-form-item>
        <el-form-item class="search-form-gutter">
          <el-tooltip class="item" effect="dark" content="Download Excel" placement="bottom">
            <el-button size="small" :circle="true" type="success" class="excel-dl-btn" @click="clickDownload"
              icon="el-icon-download"></el-button>
          </el-tooltip>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-col :span="7">
        <div id="item-dashboard-bar1"></div>
      </el-col>
      <el-col :span="7">
        <div id="item-dashboard-bar2"></div>
      </el-col>
      <el-col :span="10">
        <div id="item-dashboard-pie"></div>
      </el-col>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import AiBreadcrumb from "@/components/AiBreadcrumb";
import Guide from "@/components/Guide";
import { downloadFileAuth } from "@/utils/download-file";
import { aiApiRoot } from "@/utils/server";
import { getToken } from "@/utils/auth";
import { fetchCompare, fetchOptionsYear, fetchOptionsSeason, fetchOptionsItem } from "@/api/global-trend";

export default {
  components: { AiBreadcrumb, Guide },
  data() {
    return {
      tableData: [],
      yearList: [],
      seasonList: [],
      compareSeasonList: [],
      sexList: ["W", "M"],
      categoryList: ["TOP", "OUTER", "BOTTOM", "DRESS"],
      itemList: [],
      currentYear: "",
      currentSeason: "",
      currentCompareYear: "",
      currentCompareSeason: "",
      currentSex: "W",
      currentCategory: "DRESS",
      currentItem: "",
      currentTrendPoint: ""
    }
  },
  mounted() {
    this.fetchOptionsYear(() => {
      this.fetchData();
    });
    this.barChart1 = echarts.init(document.getElementById("item-dashboard-bar1"));
    this.barChart2 = echarts.init(document.getElementById("item-dashboard-bar2"));
    this.pieChart = echarts.init(document.getElementById("item-dashboard-pie"));
    window.addEventListener("resize", this.loadChart);

  },
  beforeUnmount() {
    window.removeEventListener("resize", this.loadChart);
    this.unloadChart();
  },
  methods: {
    loadChart() {
      this.barChart1.resize();
      this.barChart2.resize();
      this.pieChart.resize();
    },
    unloadChart() {
      this.barChart1.dispose();
      this.barChart2.dispose();
      this.pieChart.dispose();
    },
    drawBarChart1() {
      let option = {
        title: {
          text: "Date",
          padding: [5, 10],
        },
        grid: {
          top: 40,
          left: 5,
          bottom: 0,
          right: 25,
          containLabel: true
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} <br/>{c} %",
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            formatter: "{value} %"
          },
        },
        yAxis: {
          type: 'category',
          data: [],
        },
        series: [
          {
            name: "Sales",
            type: "bar",
            data: [],
          },
        ],
      };
      let max = 0;
      this.tableData.forEach((e) => {
        if (e.percentage > max) {
          max = e.percentage;
        }
        option.series[0].data.push(e.percentage);
        option.yAxis.data.push(e.name);
      });
      option.xAxis.max = max;
      this.barChart1.setOption(option, true);
    },
    drawBarChart2() {
      let option = {
        title: {
          text: "Compare Date",
          padding: [5, 10],
        },
        grid: {
          top: 40,
          left: 5,
          bottom: 0,
          right: 25,
          containLabel: true
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} <br/>{c} %",
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            formatter: "{value} %"
          }
        },
        yAxis: {
          type: 'category',
          data: []
        },
        series: [
          {
            name: "Sales",
            type: "bar",
            data: [],
          },
        ],
      };
      let max = 0;
      this.tableData.forEach((e) => {
        if (e.comparePercentage > max) {
          max = e.comparePercentage;
        }
        option.series[0].data.push(e.comparePercentage);
        option.yAxis.data.push(e.name);
      });
      option.xAxis.max = max;
      this.barChart2.setOption(option, true);
    },
    drawPieChart() {
      this.pieChart.clear();
      let option = {
        title: {
          text: this.$t("globalTrend.difference"),
          padding: [5, 10],
        },
        xAxis: {
          axisLabel: {
            formatter: '{value} %'
          },
          name: this.$t("globalTrend.proportionInRecency"),
          nameLocation: "middle",
          nameGap: 30,
          nameTextStyle: {
            fontWeight: 'bolder',
          }
        },
        yAxis: {
          axisLabel: {
            formatter: '{value} %'
          },
        },
        tooltip: {
          formatter: "{b}",
        },
        series: [
          {
            // symbolSize: 20,
            data: [

            ],
            type: 'scatter'
          }
        ]
      };
      this.tableData.forEach((e) => {
        option.series[0].data.push({
          name: e.name,
          // label: { show: true, formatter: e.name },
          value: [e.percentage, e.diff],
        });
      });
      this.pieChart.setOption(option, true);
    },
    fetchOptionsYear(callback) {
      fetchOptionsYear(this.type).then(response => {
        if (response.success) {
          this.yearList = response.result.items || [];
          if (this.yearList.length > 0) {
            this.currentYear = this.yearList[0];
            if (this.yearList.length > 1) {
              this.currentCompareYear = this.yearList[1];
            } else {
              this.currentCompareYear = this.yearList[0];
            }
          }
          this.fetchOptionsSeason(callback);
          this.fetchOptionsCompareSeason(callback);
        }
      })
    },
    fetchOptionsSeason(callback) {
      this.currentSeason = "";
      fetchOptionsSeason(this.type, { year: this.currentYear }).then(response => {
        if (response.success) {
          this.seasonList = response.result.items || [];
          if (this.seasonList.length > 0) {
            this.currentSeason = this.seasonList[0];
            this.fetchOptionsItem(callback);
          }
        }
      })
    },
    fetchOptionsCompareSeason(callback) {
      this.currentCompareSeason = "";
      fetchOptionsSeason(this.type, { year: this.currentCompareYear }).then(response => {
        if (response.success) {
          this.compareSeasonList = response.result.items || [];
          if (this.compareSeasonList.length > 0) {
            this.currentCompareSeason = this.compareSeasonList[0];
            this.fetchOptionsItem(callback);
          }
        }
      })
    },
    fetchOptionsItem(callback) {
      if (!this.currentSeason || !this.currentCompareSeason) {
        return;
      }
      this.currentItem = "";
      fetchOptionsItem(this.type, {
        category: this.currentCategory,
        years: this.currentYear + "," + this.currentCompareYear,
        seasons: this.currentSeason + "," + this.currentCompareSeason,
      }).then(response => {
        if (response.success) {
          this.itemList = response.result.items || [];
          if (this.itemList.includes("DRESS")) {
            this.currentItem = "DRESS";
          } else if (this.itemList.length > 0) {
            this.currentItem = this.itemList[0];
          }
          if (callback) {
            callback();
          }
        }
      })
    },
    fetchData() {
      fetchCompare(this.type, {
        year: this.currentYear,
        season: this.currentSeason,
        compareYear: this.currentCompareYear,
        compareSeason: this.currentCompareSeason,
        sex: this.currentSex,
        category: this.currentCategory,
        item: this.currentItem
      })
        .then((response) => {
          if (response.success) {
            this.tableData = response.result.items || [];
            this.tableData.sort((a, b) => { return a.percentage - b.percentage });
            this.drawBarChart1();
            this.drawBarChart2();
            this.drawPieChart();
          }
          this.chartLoading = false;
        })
        .catch(() => {
          this.chartLoading = false;
        });
    },
    changeYear() {
      this.fetchOptionsSeason();
    },
    changeCompareYear() {
      this.fetchOptionsCompareSeason();
    },
    changeSeason() {
      this.fetchOptionsItem();
    },
    changeCategory() {
      this.fetchOptionsItem();
    },
    clickDownload() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.preparingData"),
      });
      let queryStr = new URLSearchParams({
        year: this.currentYear,
        season: this.currentSeason,
        sex: this.currentSex,
        category: this.currentCategory,
        item: this.currentItem
      }).toString();
      downloadFileAuth(
        aiApiRoot + "/v1/global-trends/dashboard/compare/" + this.type + "/download?" + queryStr,
        "global-trend-dashboard-" +
        this.type +
        "-" +
        this.currentYear +
        "-" +
        this.currentSeason +
        "-" +
        this.currentSex +
        "-" +
        this.currentCategory +
        "-" +
        this.currentItem +
        ".xlsx",
        getToken(),
        () => {
          loading.close();
        }
      );
    }
  },
  computed: {
    type() {
      if (!this.$route.meta) {
        return null;
      }
      return this.$route.meta["type"];
    },
  }
};
</script>

<style lang="scss" scoped>
.global-trends-compare {
  .new-button {
    text-align: right;
    width: 100%;
    margin: 10px 0;

    .guide-button {
      display: inline-block;
      margin-right: 10px;
    }
  }

  .search-content {
    background-color: #fff;
    padding: 10px 0 0 10px;
    margin-bottom: 10px;

    .el-form-item {
      margin-bottom: 10px;
    }

    .search-form {
      width: auto;

      .search-form-gutter {
        margin-right: 20px;
      }
    }
  }

  #item-dashboard-bar1 {
    width: 100%;
    min-height: 248px;
    height: calc(100vh - 100px - 52.5px - 52.5px - 10px - 30px);
    margin-top: 15px;
    margin-bottom: 15px;
  }

  #item-dashboard-bar2 {
    width: 100%;
    min-height: 248px;
    height: calc(100vh - 100px - 52.5px - 52.5px - 10px - 30px);
    margin-top: 15px;
    margin-bottom: 15px;
  }

  #item-dashboard-pie {
    width: 100%;
    min-height: 248px;
    height: calc(100vh - 100px - 52.5px - 52.5px - 10px - 30px);
    margin-top: 15px;
    margin-bottom: 15px;
  }
}
</style>